var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAchievements(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16C15.866 16 19 12.866 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 12.866 8.13401 16 12 16ZM12 6C11.7159 6 11.5259 6.34084 11.1459 7.02251L11.0476 7.19887C10.9397 7.39258 10.8857 7.48944 10.8015 7.55334C10.7173 7.61725 10.6125 7.64097 10.4028 7.68841L10.2119 7.73161C9.47396 7.89857 9.10501 7.98205 9.01723 8.26432C8.92945 8.54659 9.18097 8.84072 9.68403 9.42898L9.81418 9.58117C9.95713 9.74833 10.0286 9.83191 10.0608 9.93531C10.0929 10.0387 10.0821 10.1502 10.0605 10.3733L10.0408 10.5763C9.96476 11.3612 9.92674 11.7536 10.1565 11.9281C10.3864 12.1025 10.7318 11.9435 11.4227 11.6254L11.6014 11.5431C11.7978 11.4527 11.8959 11.4075 12 11.4075C12.1041 11.4075 12.2022 11.4527 12.3986 11.5431L12.5773 11.6254C13.2682 11.9435 13.6136 12.1025 13.8435 11.9281C14.0733 11.7536 14.0352 11.3612 13.9592 10.5763L13.9395 10.3733C13.9179 10.1502 13.9071 10.0387 13.9392 9.93531C13.9714 9.83191 14.0429 9.74833 14.1858 9.58118L14.316 9.42898C14.819 8.84072 15.0706 8.54659 14.9828 8.26432C14.895 7.98205 14.526 7.89857 13.7881 7.73161L13.5972 7.68841C13.3875 7.64097 13.2827 7.61725 13.1985 7.55334C13.1143 7.48944 13.0603 7.39258 12.9524 7.19887L12.8541 7.02251C12.4741 6.34084 12.2841 6 12 6Z",
    fill: "url(#paint0_linear_6468_1320)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49517 12.9945L2.99206 14.5509C2.45194 15.1101 2.18188 15.3897 2.08843 15.6265C1.87548 16.1661 2.05772 16.7647 2.52138 17.0485C2.72486 17.1731 3.09187 17.2119 3.82589 17.2895C4.2403 17.3334 4.44755 17.3553 4.6211 17.4218C5.00966 17.5708 5.31191 17.8837 5.45575 18.286C5.52 18.4657 5.54117 18.6803 5.5835 19.1094C5.65848 19.8694 5.69597 20.2494 5.81628 20.4601C6.09042 20.9402 6.66852 21.1289 7.18967 20.9084C7.41837 20.8116 7.68843 20.532 8.22855 19.9727L10.7106 17.4028C8.01306 16.9923 5.73225 15.3139 4.49517 12.9945Z",
    fill: "url(#paint1_linear_6468_1320)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2894 17.4028L15.7715 19.9727C16.3116 20.532 16.5816 20.8116 16.8103 20.9084C17.3315 21.1289 17.9096 20.9402 18.1837 20.4601C18.304 20.2494 18.3415 19.8694 18.4165 19.1094C18.4588 18.6803 18.48 18.4657 18.5442 18.286C18.6881 17.8837 18.9903 17.5708 19.3789 17.4218C19.5525 17.3553 19.7597 17.3334 20.1741 17.2895C20.9081 17.2119 21.2751 17.1731 21.4786 17.0485C21.9423 16.7647 22.1245 16.1661 21.9116 15.6265C21.8181 15.3897 21.5481 15.1101 21.0079 14.5509L19.5048 12.9945C18.2677 15.3139 15.9869 16.9923 13.2894 17.4028Z",
    fill: "url(#paint2_linear_6468_1320)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6468_1320",
    x1: 12.908,
    y1: 2,
    x2: 12.908,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6468_1320",
    x1: 13.2971,
    y1: 12.9945,
    x2: 13.2971,
    y2: 20.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6468_1320",
    x1: 13.2971,
    y1: 12.9945,
    x2: 13.2971,
    y2: 20.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2ABDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0497FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievements);
export default __webpack_public_path__ + "static/media/achievements.aee67701056c2dab2dcc9e98b88a0f67.svg";
export { ForwardRef as ReactComponent };